module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowThin.b0916d1.woff2";